import intlTelInput from 'intl-tel-input';
import { de, en, fr } from 'intl-tel-input/build/js/i18n';

const locales = { de, en, fr };

const input = document.querySelector('.js-phone-input');
const countryCodeInput = document.querySelector('.js-phone-country-code');
const fullNumberInput = document.querySelector('.js-phone-full-number');

export const PhoneCountryCodes = () => {
  if (!input) return;

  if (fullNumberInput && fullNumberInput.value) input.value = fullNumberInput.value;

  const iti = intlTelInput(input, {
    onlyCountries: [
      'al', 'ad', 'am', 'at', 'az', 'pt', 'by', 'be', 'ba', 'bg', 'hr', 'cz', 'dk', 'ee',
      'fo', 'fi', 'fr', 'ge', 'de', 'gi', 'gr', 'gl', 'hu', 'is', 'ie', 'it', 'kz', 'kg',
      'lv', 'li', 'lt', 'lu', 'mk', 'mt', 'md', 'mc', 'nl', 'no', 'pl', 'pt', 'ro', 'ru',
      'sm', 'rs', 'sk', 'si', 'es', 'se', 'ch', 'tj', 'tr', 'tm', 'ua', 'gb', 'uz', 'va'
    ],
    initialCountry: 'ch',
    i18n: locales[I18n.locale] || de,
    separateDialCode: true,
    hiddenInput: () => ({ country: 'country_code' }),
    loadUtils: () => import('intl-tel-input/build/js/utils')
  });

  window.iti = iti;

  const updatePhoneFields = () => {
    const phoneValue = input.value.trim();
    
    if (phoneValue === '' || phoneValue === `+${iti.getSelectedCountryData().dialCode}`) {
      if (countryCodeInput) countryCodeInput.value = '';
      if (fullNumberInput) fullNumberInput.value = '';
    } else {
      if (countryCodeInput) countryCodeInput.value = `+${iti.getSelectedCountryData().dialCode}`;
      if (fullNumberInput) fullNumberInput.value = iti.getNumber();
    }
  };

  iti.promise.then(() => {
    const setCountryCode = () => {
      countryCodeInput.value = `+${  iti.getSelectedCountryData().dialCode}`;
    };

    setCountryCode();

    input.addEventListener('countrychange', function() {
      setCountryCode();
    });

    updatePhoneFields();

    input.addEventListener('countrychange', updatePhoneFields);
    input.addEventListener('input', updatePhoneFields);
    input.addEventListener('blur', updatePhoneFields);
  });
};

export const validateIntPhoneNumber = () => {
  if (input.value) fullNumberInput.value = countryCodeInput.value + input.value.replace(/\D/g, '');

  const errorMap = [I18n.t('javascript.account.invalid_number'), I18n.t('javascript.account.invalid_country_code'), I18n.t('javascript.account.phone_is_too_short'), I18n.t('javascript.account.phone_is_too_long'), I18n.t('javascript.account.invalid_number')];
  if (!window.iti || !window.iti.isValidNumber()) {
    const errorCode = window.iti ? window.iti.getValidationError() : 0;
    return errorMap[errorCode] || I18n.t('javascript.account.invalid_number');
  }
};
